import { render, staticRenderFns } from "./employeeCertifications.vue?vue&type=template&id=635ce366&scoped=true"
import script from "./employeeCertifications.vue?vue&type=script&lang=js"
export * from "./employeeCertifications.vue?vue&type=script&lang=js"
import style0 from "./employeeCertifications.vue?vue&type=style&index=0&id=635ce366&prod&scoped=true&lang=css"
import style1 from "./employeeCertifications.vue?vue&type=style&index=1&id=635ce366&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ce366",
  null
  
)

export default component.exports